import api from './api';

const BASE = '/costing';

export const costingApi = {
  // Factory settings
  getFactorySettings: () => api.get(`${BASE}/factory-settings/`),
  getFactorySetting: (id) => api.get(`${BASE}/factory-settings/${id}/`),
  createFactorySettings: (data) => api.post(`${BASE}/factory-settings/`, data),
  updateFactorySettings: (id, data) => api.patch(`${BASE}/factory-settings/${id}/`, data),
  deleteFactorySettings: (id) => api.delete(`${BASE}/factory-settings/${id}/`),

  // Peripheral equipment
  getPeripherals: (params) => api.get(`${BASE}/peripheral-equipment/`, { params }),
  createPeripheral: (data) => api.post(`${BASE}/peripheral-equipment/`, data),
  updatePeripheral: (id, data) => api.patch(`${BASE}/peripheral-equipment/${id}/`, data),
  deletePeripheral: (id) => api.delete(`${BASE}/peripheral-equipment/${id}/`),

  // Packaging schemes
  getPackagingSchemes: () => api.get(`${BASE}/packaging-schemes/`),
  createPackagingScheme: (data) => api.post(`${BASE}/packaging-schemes/`, data),
  updatePackagingScheme: (id, data) => api.patch(`${BASE}/packaging-schemes/${id}/`, data),
  deletePackagingScheme: (id) => api.delete(`${BASE}/packaging-schemes/${id}/`),

  // Calculations (archive)
  getCalculations: (params) => api.get(`${BASE}/calculations/`, { params }),
  getCalculation: (id) => api.get(`${BASE}/calculations/${id}/`),
  calculate: (data) => api.post(`${BASE}/calculations/calculate/`, data),
  updateCalculation: (id, data) => api.patch(`${BASE}/calculations/${id}/`, data),
  setActive: (id) => api.post(`${BASE}/calculations/${id}/set-active/`),
  deleteCalculation: (id) => api.delete(`${BASE}/calculations/${id}/`),
  uploadCalculationImage: (id, file) => {
    const formData = new FormData();
    formData.append('image', file);
    return api.post(`${BASE}/calculations/${id}/upload-image/`, formData);
  },
  attachCalculationToLead: (id, leadId) => api.patch(`${BASE}/calculations/${id}/`, { lead: leadId }),

  // ERP defaults (for product+machine+form combo)
  getERPDefaults: (productId, machineId, pressFormId) =>
    api.get(`${BASE}/erp-defaults/`, {
      params: { product_id: productId, machine_id: machineId, press_form_id: pressFormId },
    }),

  // Machine costing profiles
  getMachineProfiles: () => api.get(`${BASE}/machine-profiles/with-all-machines/`),
  upsertMachineProfile: (data) => api.post(`${BASE}/machine-profiles/upsert/`, data),

  // Raw material delivery %
  getMaterialDeliveries: () => api.get(`${BASE}/material-delivery/with-all-materials/`),
  upsertMaterialDelivery: (data) => api.post(`${BASE}/material-delivery/upsert/`, data),

  // Dye delivery %
  getDyeDeliveries: () => api.get(`${BASE}/dye-delivery/with-all-dyes/`),
  upsertDyeDelivery: (data) => api.post(`${BASE}/dye-delivery/upsert/`, data),

  // Product list with all ERP data for auto-fill
  getProductList: () => api.get(`${BASE}/product-list/`),

  // ERP packaging materials list
  getPackagingMaterials: () => api.get(`${BASE}/packaging-materials/`),

  // Product cost profiles (стандарт-костинг)
  getCostProfiles: () => api.get(`${BASE}/cost-profiles/`),
  createCostProfile: (data) => api.post(`${BASE}/cost-profiles/`, data),
  updateCostProfile: (id, data) => api.patch(`${BASE}/cost-profiles/${id}/`, data),
  deleteCostProfile: (id) => api.delete(`${BASE}/cost-profiles/${id}/`),
  importProfilesFromCalcs: () => api.post(`${BASE}/cost-profiles/import-from-calculations/`),

  // Bulk recalculate + current costs
  bulkRecalculate: () => api.post(`${BASE}/bulk-recalculate/`),
  getCurrentCosts: () => api.get(`${BASE}/current-costs/`),
  getProductHistory: (productId) => api.get(`${BASE}/product-history/${productId}/`),
  getMachineSensitivity: (calcId) => api.get(`${BASE}/machine-sensitivity/${calcId}/`),
};

export default costingApi;
